// stores/menuService.js
import { defineStore } from 'pinia';

export const useMenuServiceStore = defineStore(
  "menuService",
  () => {
    const config = useRuntimeConfig();
    const baseApi = config.public.baseApi;
    const { locale } = useI18n();

    // ตัวแปรเก็บ cache
    const menuCache = ref({});

    const getCacheKey = (path) => {
      return `${locale.value}:${path}`;
    };

    const fetchMenu = async (paths = [], params = {}) => {
      if (!Array.isArray(paths)) {
        paths = [paths];
      }

      const results = await Promise.all(
        paths.map(async (path) => {
          const cacheKey = getCacheKey(path+params);

          // ถ้ามี cache อยู่แล้ว ใช้เลย
          if (menuCache.value[cacheKey]) {
            return {
              path,
              data: menuCache.value[cacheKey],
              fromCache: true,
            };
          }

          // รวม query string จาก route และ params ที่อาจถูกส่งมา
          const query = new URLSearchParams({
            ...params,
          }).toString();

          const url = `${baseApi}/${locale.value}/menus${path}${
            query ? `?${query}` : ""
          }`;

          // ถ้าไม่มี cache ให้ fetch ใหม่
          const { data } = await useFetch(url);

          // เซฟลง cache
          if (data.value) {
            menuCache.value[cacheKey] = data.value;
          }

          return {
            path,
            data: data.value,
            fromCache: false,
          };
        })
      );

      // คืนค่าข้อมูลทั้งหมดในรูปแบบ object
      return results.reduce((acc, item) => {
        acc[item.path] = item.data;
        return acc;
      }, {});
    };

    return {
      fetchMenu,
      menuCache,
    };
  }
);